import React from 'react'
import { useNavigate } from 'react-router-dom';

import './Card.css' // Import the CSS file for styles

const Card = ({heading = '', count = 0, isScan = false, url='', isNavigate=false}) => {
  const navigate = useNavigate();

  const getCountValue = (num: any) => {
    if (heading === 'Revenue' || heading === 'Profit' || heading === "Total Sotck's Amount") {
      return num?.toLocaleString('en-US')
    }
    return num
  }

  const onUrlChange = () => {
    if(isNavigate)
    navigate(url);
  }

  return (
    <div className={isScan ? 'scanBox' : 'box'} onClick={onUrlChange}>
      <p className='top-head'>{heading}</p>
      <div>
        <p className={heading === 'Expiry Soon' ? 'cont-text red' : 'cont-text'}>
          {' '}
          {heading === 'Revenue' || heading === 'Profit' || heading === "Total Sotck's Amount"
            ? '₹'
            : ''}{' '}
          {getCountValue(count)}
        </p>
      </div>
    </div>
  )
}

export default Card
